// extracted by mini-css-extract-plugin
module.exports = {"loader":"CustomPageLoader_loader__2MLju","spin":"CustomPageLoader_spin__2ZGb9","overlayed":"CustomPageLoader_overlayed__32Pi1"};